<template><div class="unit-vpn-sd-card">
  <div class="path">
    <span>SD Card</span>
    <template v-for="(name,i) in path">
      <span :key="'s-'+i"> / </span>
      <a href="#" @click.prevent="navigatePath(path.slice(0,i+1))" :key="'n-'+i" v-html="name" />
    </template>
    {{ ' ' }}
    <loading v-if="listing" />
    <div class="error" v-if="listError">
      Warning: Failed to get directory
      listing<span v-if="'rc' in listError"> (error code: {{ listError.name }}).</span>
      <span v-else>.</span>
    </div>
  </div>
  <table class="list">
  <thead>
    <tr><th>Name</th><th>Size</th><th v-if="list && list.length && list[0].length >= 4">Modified</th></tr>
  </thead>
  <tbody>
    <tr v-for="(item,i) in list" :key="'i-'+i" @click.prevent="navigateItem(item)">
      <td>
        <span v-if="item[1] & 0x10" class="material-icons">subdirectory_arrow_right</span>
        <span class="name" v-html="item[0]" />
      </td>
      <td>
        <span v-if="item[2]" class="size">{{Math.round(item[2]/1024)}} KB</span>
        <span v-else>-</span>
      </td>
      <td v-if="3 in item" v-html="item[3]" />
    </tr>
  </tbody>
  </table>
  <modal-dialog v-if="downloading" :strong="true" @close="cancelDownload">
    <div><span v-if="!downloadError">Downloading</span> <b v-html="downloading"></b></div>
    <div v-if="downloadError" class="error">An error occurred during the download.</div>
    <div v-if="downloadProgress">
      {{ Math.round(downloadProgress.loaded / 1024) }}
      <template v-if="downloadProgress.total">
        / {{ Math.round(downloadProgress.total / 1024) }}
      </template>
      KB
      <template v-if="downloadProgress.total">
        ({{ Math.round(downloadProgress.loaded * 100 / downloadProgress.total) }}%)
      </template>
    </div>
    <div v-else><i>Initializing download...</i></div>
    <button @click="cancelDownload" v-if="!downloadError">Cancel</button>
  </modal-dialog>
</div></template>
<script>
import Loading from '../Loading'
import ModalDialog from '../ModalDialog'
export default {
  name: 'unit-vpn-sd-card',
  components: { Loading, ModalDialog },
  props: ['api','info'],
  data() {
    return {
      drive: 0,
      path: ['tmvlogs'],
      list: [],
      listing: false,
      listError: null,
      downloading: false,
      downloadProgress: null,
      downloadError: null,
    }
  },
  created() {
    this.listdir()
  },
  methods: {
    async listdir() {
      try {
        this.listing = true
        this.listError = null
        this.list = []
        await this.api.streamDirectory({
          path: `${this.drive}:${this.path.join('/')}`,
          onItemReceived: (item) => {
            if (item[0] !== '.') {
              if (item.length >= 4) {
                item[3] = new Date(item[3] * 1000).toISOString()
                item[3] = item[3].substring(0, item[3].length - 5)
              }
              this.list.push(item)
            }
          },
        })
      } catch(e) {
        console.error('listdir error:', e)
        this.listError = e
      } finally {
        this.listing = false
      }
    },
    navigatePath(path) {
      this.path = path
      this.listdir()
    },
    navigateItem(item) {
      if (item[1] & 0x10) {
        this.path.push(item[0])
        this.listdir()
      } else {
        this.downloadFile(item[0])
      }
    },
    async downloadFile(fn) {
      try {
        let path = this.path.slice()
        path.push(fn)
        this.downloading = fn
        this.downloadError = null
        this.downloadProgress = null
        await this.api.getSDCardFile({
          path: `${this.drive}:${path.join('/')}`,
          saveAs: fn,
          onDownloadProgress: (e) => {
            this.downloadProgress = e
          },
        })
        this.downloading = false
      } catch(e) {
        if (e.constructor.name === 'CancelledError')
          this.downloading = false
        else
          this.downloadError = e
      }
    },
    cancelDownload() {
      this.api.cancel()
      this.downloading = false
    },
  },
}
</script>
<style lang="scss">
.unit-vpn-sd-card {
  .path {
    line-height: 40px;
    .loading {
      vertical-align: top;
    }
  }
  .list {
    th, td { padding-right: 20px; text-align: left; }
    tbody {
      tr { cursor: pointer; }
    }
    .material-icons {
      vertical-align: bottom;
    }
    .name {
      text-decoration: underline;
    }
  }
}
</style>
